import { render, staticRenderFns } from "./AdministrativeFileReadOnly.vue?vue&type=template&id=16f850ae&"
import script from "./AdministrativeFileReadOnly.vue?vue&type=script&lang=js&"
export * from "./AdministrativeFileReadOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports